export default __webpack_public_path__ + "images/loggedout/home/modularPage/modularpink_curve-46740e7bb1ddb2be066fccc090c316f2.svg";